import React, { Component } from 'react'
import styled from 'styled-components'

import EquipmentToggler from 'components/EquipmentToggler'

import { generateMediaUrl } from 'utils'
import groupBy from 'lodash/groupBy'
import findIndex from 'lodash/findIndex'
import mapValues from 'lodash/mapValues'
import toArray from 'lodash/toArray'

const mapObjectToarray = (object) => {
  return toArray(
    mapValues(object, (value, key) => {
      return {
        key,
        id: key,
        value
      }
    })
  )
}

/* eslint-disable camelcase */
export default class EquipmentsModal extends Component {
  constructor () {
    super()
    this.state = {
      enabled: []
    }
  }

  toggleEquipment = (equipment) => {
    const clone = { ...equipment }
    const { selectedDivision } = this.props
    let enabled = this.state.enabled
    const eqInArray = findIndex(enabled, ({ id }) => id === clone.id)

    if (eqInArray !== -1) {
      enabled.splice(eqInArray, 1)
    } else {
      clone.house_divisions = selectedDivision.id
      enabled.push(clone)
    }

    this.setState({
      enabled
    })
  }

  componentWillMount () {
    document.body.style.overflow = 'hidden'
    const selectedEquipments = [ ...this.props.selectedEquipments ]
    this.setState({
      enabled: selectedEquipments
    })
  }

  componentWillUnmount () {
    document.body.style.overflow = 'initial'
  }

  render () {
    const {
      selectedDivision,
      offerType,
      onAddEquipments,
      toggle,
      offerTypeName
    } = this.props

    // Get equipments based on offertype and division
    let equipments = [ ...this.props.equipments ]
    let groupEquipments = equipments && equipments
        .filter(({ offer_type }) => offer_type === offerType)
        .filter(({ house_divisions }) => {
          return house_divisions.indexOf(selectedDivision.id) !== -1
        })

    groupEquipments = groupBy(groupEquipments, ({ equipment_icon }) => equipment_icon ? equipment_icon.icon : null)
    groupEquipments = mapObjectToarray(groupEquipments)

    return (
      <Outside>
        <RightContainer>
          <RightHeader>
            <Title>Adicionar equipamento de consumo de {offerTypeName}</Title>
            <Close onClick={() => toggle(null)} />
          </RightHeader>

          <EquipmentsList>
            {groupEquipments && groupEquipments.map((item) => {
              return (
                <Item key={item.id}>
                  {item.key && <Icon src={generateMediaUrl(item.key)} />}
                  <List>
                    {item.value && item.value.map((equipment) =>
                      <EquipmentToggler
                        key={equipment.id}
                        equipment={equipment}
                        onToggle={() => this.toggleEquipment(equipment)}
                        selected={findIndex(this.state.enabled, ({ id }) => id === equipment.id) !== -1}
                      />
                      )}
                  </List>
                </Item>
              )
            })}
          </EquipmentsList>

          <EquipmentAddButton onClick={() => onAddEquipments(this.state.enabled)}>Adicionar Equipamentos</EquipmentAddButton>
        </RightContainer>
      </Outside>
    )
  }
}

const EquipmentAddButton = styled.div`
width: 280px;
background: linear-gradient(270deg, #006736 0%, #93C13E 100%);
text-transform: uppercase;
flex: 0.05;
text-align: center;
font-weight: bold;
font-size: 16px;
letter-spacing: 1px;
margin: 40px auto;
color: #FFF;
display: flex;
align-items: center;
justify-content: center;
padding: 10px 0;
cursor: pointer;

`

const Outside = styled.div`
position: fixed;
top: 0;
left: 0;
bottom: 0;
right: 0;
background-color: rgba(239,239,239,0.8);
z-index: 999;
`

const RightContainer = styled.div`
width: 528px;
position: absolute;
right: 0;
top: 0;
bottom: 0;
background-color: #FFFFFF;
box-shadow: -2px 0 20px 0 rgba(0,0,0,0.1);
display: flex;
flex-direction: column;

  @media(max-width: 600px) {
    width: 100%;
  }
`

const Title = styled.span`
color: #010101;
font-size: 24px;
font-weight: bold;
line-height: 32px;
text-align: left;
text-transform: uppercase;
flex: 0.8;

@media screen and (max-width: 768px) {
  font-size: 16px;
  line-height: 24px;
}

@media screen and (max-width: 320px) {
  font-size: 14px;
  line-height: 18px;
}
`

const RightHeader = styled.div`
display: flex;
align-items: center;
justify-content: space-between;
box-shadow: 0 1px 10px 0 rgba(0,0,0,0.05);
padding: 40px;
flex: 0.15;
`

const Close = styled.span`
  flex: 0.1;
  display: block;
  text-align: center;
  position: relative;
  cursor: pointer;

  &:before {
    content: "✕";
    font-size: 20px;
    line-height: 24px;
    color: #BABABA;
    top: 0;
    position: absolute;
    left: 0;
    width: 100%;
    border: 1px solid #BABABA;
    width: 24px;
    height: 24px;
    display: block;
    text-align: center;
    position: relative;
    cursor: pointer;
  }
`

const EquipmentsList = styled.div`
padding: 10px 40px;
flex: 0.80;
display: flex;
overflow: auto;
flex-direction: column;
`

const Item = styled.div`
width: 100%;
margin-bottom: 40px;
white-space: nowrap;
`

const Icon = styled.img`
display: inline-block;
vertical-align: middle;
white-space: normal;
width: 25px;
margin-right: 20px;
`

const List = styled.div`
flex: 1;
display: inline-block;
vertical-align: middle;
width: calc(100% - 25px);
white-space: normal;
`



// WEBPACK FOOTER //
// ./src/containers/EquipmentsModal/index.js